class CommonContent {
  constructor() {
    this.welWrapper = $('#_wrapDealContents');
    this.bOptionDeal = TMON.oApp.htStorage.htStaticData.bOptionDeal; // 옵션만 보기 여부
    this.nCols = 1;
    this.nRows = 1;
    this.tlCode = {
      area: {
        openOptionDeal: 'DDO0',
      },
    };
    this.htDealContentInfo =
      TMON.oApp.htStorage.htStaticData.htDealContentInfo || {};
    this.selectedList =
      TMON.oApp.htStorage.optionInfo &&
      TMON.oApp.htStorage.optionInfo.selectedList
        ? TMON.oApp.htStorage.optionInfo.selectedList
        : [];
    this.nOptionDealIndex =
      this.selectedList.length > 0 ? this.selectedList[0].idx : 0;
    this.bShowAdditionalButton =
      TMON.oApp.htABTest.addBuyFeatureInOptionList === 'B' &&
      TMON.oApp.sPlatform !== 'PW'; // [ABTest][DECE-1714] 상세보기, 옵션선택 버튼 노출여부
    this.bDetailviewAvailable =
      TMON.oApp.htStorage.htStaticData.bDetailviewAvailable; // 옵션 자세히보기 가능 여부
    this.renderContentsVideo =
      TMON.oApp.htStorage.htStaticData.htDealInfo.isContentsVideo; // 컨텐츠 동영상 사용 여부
    this.PREFIX_IMAGE_URL = TMON.htStaticData.sImgCdn; // cdn 주소가 붙어있지 않은 데이터에 붙임
  }

  get contentInfo() {
    return this.htDealContentInfo.contentInfo; // content정보
  }

  get contentType() {
    return this.htDealContentInfo.contentType; // contentType
  }

  get dealNo() {
    return this.htDealContentInfo.dealNo; // 메인딜 번호
  }

  /**
   * 서머리 이미지 / 리뷰 이미지의 데이터를 UI에서 사용·레이지로드를 위해 변환
   */
  getReplacedInnerDivHtml(item, sWrapClass) {
    const REGEX = /<img(.*?)src=['"](.*?)blank.png['"](.*?)data-original=['"](.*?)['"]/gim;
    const REGEX2 = /<img(.*?)src=['"](.*?)['"](.*?)>/gim;
    const innerHtml = item
      .replace(REGEX, '<img src="$4"')
      .replace(
        REGEX2,
        `<img src="${this.PREFIX_IMAGE_URL}/static2/img/blank.png" class="unload" data-src="$2">`
      );
    return `<div class="review_opt r6 _replace ${sWrapClass}">${innerHtml}</div>`;
  }

  /**
   * 여행필수 체크사항
   */
  getTravelCheckListHtml(list) {
    return `<div class="bx_ct tour_chk_notice">
                <div class="ct_wrp">
                    <h4 class="tit_align_top">여행 필수 체크사항</h4>
                    <div class="ct">
                        <table cellspacing="0" border="1" summary="여행 필수 체크사항 안내표" class="tbl_info">
                            <colgroup>
                                <col style="width:35%">
                            </colgroup>
                            <tbody>${list
                              .map(
                                item =>
                                  `<tr>
                                        <th scope="row">${item.title}</th>
                                        <td>${item.desc}</td>
                                    </tr>`
                              )
                              .join('')}</tbody>
                        </table>
                    </div>
                </div>
            </div>`;
  }

  /* video contents */

  makeVideoContent() {
    return this.renderContentsVideo
      ? `<div id="_wrapContentsVideo">
            <div id="youtube-wrapper" class="youtube-wrapper">
                <div id="content-youtube-player"></div>
                ${
                  TMON.oApp.sPlatform !== 'PW'
                    ? `<div id="_youtube_button" style="position:absolute;top:0;right:0;bottom:0;left:0;display:none">
                          <button type="button" data-role="youtubePlayToggle" style="position:absolute;width:100%;top:0;right:0;bottom:0;left:0;">
                            <span class="blind">재생/멈춤</span>
                          </button>
                        </div>`
                    : ''
                }
                <div id="playerLoader"></div>
            </div>
            <div id="_youtubeDontSupportIE9" class="caution" style="display:none">
              <strong>Internet Explorer 9 또는 그 이하의 브라우저를 사용하실 경우, 동영상 재생이 제한될 수 있습니다.<br>브라우저를 최신 버전으로 업데이트 해 주세요</strong>
            </div>
          </div>`
      : '';
  }

  makeOptionDetailLook() {
    if (!this.bOptionDeal && this.bDetailviewAvailable) {
      TMON.oApp.setStorage('renderDetailViewAvailable', true);
      return '<div class="r3 banner_img_desc"><div class="txt_area"><h4>상품 자세히보기</h4><p>옵션 이미지를 누르면<br /><strong>상품 상세설명</strong>을<br />볼 수 있어요<span>!</span></p></div></div>';
    }
    return '';
  }

  /**
   * review-opt Element 초기화
   */
  initReviewOpt(className, sHTML) {
    const welReviewOpt = this.welWrapper.find(className);
    if (welReviewOpt.length === 0) {
      this.welWrapper.append(sHTML);
    }
  }

  makeMiscContent() {
    const { miscContent = '' } = this.contentInfo;
    return miscContent
      ? this.getReplacedInnerDivHtml(miscContent, 'misc_content')
      : '';
  }

  makeTravelCheckList() {
    const { travelCheckList } = this.contentInfo;
    return TMON.htStaticData.bIsTourDeal &&
      travelCheckList &&
      travelCheckList.length > 0
      ? this.getTravelCheckListHtml(travelCheckList)
      : '';
  }

  /* 전체 옵션 모두 보기 버튼 그리기(옵션딜에서 노출) */
  makeAllButton() {
    return TMON.htStaticData.htDealInfo.optionCnt > 1
      ? `<a class="btn_deal_all" href="${TMON.htLocal.htURL.www_m_deals}${
        this.dealNo
      }${
        TMON.view_mode === 'app' ? `?${TMON.sAppQuery}` : ''
      }" data-tlarea="DDAD" data-tlord="1">
        전체 옵션 모두 보기
      </a>`
      : '';
  }

  getImgHtml(src, bShow) {
    const blankSrc = `${this.PREFIX_IMAGE_URL}/static2/img/blank.png`;
    const display = bShow ? '' : ' style="display:none"';
    return `<img class="unload" src="${blankSrc}" data-src="${src}" role="presentation"${display}>`;
  }

  /**
   * 레이지로드를 위한 이미지 엘리먼트 반환
   */
  getLazyImgHtml(src, bShow) {
    return this.getImgHtml(TMON.util.preventMixedContent(src), bShow);
  }

  getLazyOriginalImgHtml(src, bShow) {
    return this.getImgHtml(src, bShow);
  }
}
export default CommonContent;
